import { mapState } from 'vuex'

import IFRAME_MESSAGE_TYPES from 'shared/constants/iframeMessageTypes'
import iframeLib from 'lib/iframe'
import config from 'src/config'
import eventBus from 'lib/eventBus'
import domUtils from 'utils/domUtils'

const iframeWidgetBaseMixin = {
  data() {
    return {}
  },
  computed: {
    ...mapState({
      iframeId: (state) => state.innerIframe.iframeId,
    }),
  },
  watch: {
    $route() {
      this.publishDimensions()
    },
  },
  methods: {
    publishDimensions(options = {}) {
      if (!this.$refs.widgetContainer) {
        console.log('widget has no ref - resizing disabled') //eslint-disable-line
        return
      }

      let height
      let width

      try {
        //NOTE: all iframe widgets need to have a ref="widgetContainer" attribution set on the outermost container element
        height = domUtils.outerHeight(this.$refs.widgetContainer, true)
        width = domUtils.outerWidth(this.$refs.widgetContainer, true)
      } catch (err) {
        return
      }

      if (options.minHeight && options.minHeight > height) height = options.minHeight
      if (this.minHeight && this.minHeight > height) height = this.minHeight
      if (options.maxHeight && options.maxHeight < height) height = options.maxHeight

      this.publishIframeMessage(IFRAME_MESSAGE_TYPES.IFRAME_DIMENSIONS_UPDATED, {
        height,
        width,
      })
    },
    onIframeBlurred() {
      //implement in sub class
    },
    onWindowScrolled() {
      //implement in sub class
    },
    onShowModal() {
      //implement in sub class
    },
    publishIframeMessage(type, message) {
      iframeLib.publish(
        {
          name: config.IFRAME_MESSAGE_NAME,
          type,
          iframeId: this.iframeId,
          data: message,
        },
        {
          parent: true,
        }
      )
    },
  },
  created() {
    this.$store.dispatch('setInnerIframeId', this.$route.query.iframeId)

    iframeLib.subscribe('message', (message) => {
      if (
        message &&
        message.data &&
        message.data.name === config.IFRAME_MESSAGE_NAME &&
        message.data.iframeId === this.iframeId
      ) {
        if (message.data.type === IFRAME_MESSAGE_TYPES.IFRAME_BLURRED) {
          this.onIframeBlurred()
        } else if (message.data.type === IFRAME_MESSAGE_TYPES.WINDOW_SCROLLED) {
          this.onWindowScrolled(message.data.data)
        }
      }
    })

    //let any listening iframes know the widget is ready
    iframeLib.publish(
      {
        name: config.IFRAME_MESSAGE_NAME,
        type: IFRAME_MESSAGE_TYPES.WIDGET_READY,
        iframeId: this.iframeId,
        data: {},
      },
      {
        parent: true,
      }
    )
  },
  mounted() {
    this.publishDimensions()

    eventBus.$on('updated', (options) => {
      this.publishDimensions(options)
    })

    eventBus.$on('dimensionsUpdated', (options) => {
      this.publishDimensions(options)
    })
  },
  updated() {
    this.publishDimensions()
  },
}

export default iframeWidgetBaseMixin



// WEBPACK FOOTER //
// ./src/mixins/iframeWidgetBase.js